import React, { useCallback } from 'react';
import Dropbox from './components/dropbox';
import { FileWithPath } from 'react-dropzone';
import DropboxInner from './components/dropboxInner';
import { SxProps } from '@mui/material';

export type UploadedFile = {
  originalFile: File;
};
export type UploadedReadedFile = {
  dataUrl: string;
  originalFile: File;
};

export default function UploadArea<
  IsDataUrl extends boolean,
  T extends IsDataUrl extends true ? UploadedReadedFile : UploadedFile,
>({
  handleAddFile,
  areMultipleUploadsAllowed = true,
  text,
  buttonText,
  icon,
  sx,
  innerSx,
  accept,
  error,
  isDataUrl,
  triggerMode,
}: {
  isDataUrl: IsDataUrl;
  handleAddFile: (image: T) => void;
  areMultipleUploadsAllowed?: boolean;
  text?: string;
  buttonText?: string;
  icon?: React.ReactNode;
  sx?: SxProps;
  innerSx?: SxProps;
  accept?: Record<string, string[]>;
  error?: boolean;
  triggerMode?: boolean;
}) {
  const onDrop = useCallback(
    (acceptedFiles: FileWithPath[]) => {
      acceptedFiles.forEach((file, index) => {
        const reader = new FileReader();

        if (isDataUrl) {
          reader.onload = function (e) {
            const src = e?.target?.result as string;

            if (!src) {
              return;
            }
            handleAddFile({
              dataUrl: src,
              originalFile: file,
            } as T);
          };
          reader.readAsDataURL(file);
        } else {
          handleAddFile({
            originalFile: file,
          } as T);
        }
      });
    },
    [handleAddFile, isDataUrl]
  );

  const errorSx = error
    ? {
        borderColor: 'error.main',
      }
    : {};

  return triggerMode ? (
    <DropboxInner
      sx={{ ...errorSx, ...innerSx }}
      text={text}
      buttonText={buttonText}
      icon={icon}
      onDrop={onDrop}
      accept={accept}
      areMultipleUploadsAllowed={areMultipleUploadsAllowed}
      triggerMode={triggerMode}
    ></DropboxInner>
  ) : (
    <Dropbox sx={{ ...sx }}>
      <DropboxInner
        sx={{ ...errorSx, ...innerSx }}
        text={text}
        buttonText={buttonText}
        icon={icon}
        onDrop={onDrop}
        accept={accept}
        areMultipleUploadsAllowed={areMultipleUploadsAllowed}
      ></DropboxInner>
    </Dropbox>
  );
}
